<template>
    <div style="width: 100%;background:#fff;height:100%">
        <div class="head-top">
            <el-button class="layui-btn layui-btn-primary" @click="goBack()" style="border: 0;color: #4D7BF4;">返回</el-button>
            <el-breadcrumb separator="/" style="margin-left:20px;">
                <el-breadcrumb-item :to="{ path: '/progress' }">进度管理</el-breadcrumb-item>
                <el-breadcrumb-item>{{plan.planName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="layui-row secondCon userCon" style="height: calc( 100vh - 170px );">
            <div class="layui-col-lg12" style="height:100%;overflow: auto;">
                <!-- <div class="layui-tab-content">
                    <div class="layui-tab-item layui-show userListCon"> -->
                        <form class="layui-form selectForm" style="height:105px;">
                            <el-col :span="20" style="text-align: left;padding-left: 20px;">
                                <p class="dute-title">施工计划描述</p>
                                <p class="desc">
                                    {{plan.planDescribe}}
                                </p>
                            </el-col>
                            <el-col :span="4" style="text-align: right;margin-top: 8px;display: flex;justify-content: flex-end;padding-right: 20px;">
                                <el-button class="layui-btn" @click="addDute" style="background: #4D7BF4;color:#fff;">新增工序</el-button>
                            </el-col>
                        </form>
                        <div class="build-table">
                            <el-table
                                :default-sort="{prop: 'date', order: 'descending'}"
                                :data="tableDataEnd"
                                height="100%"
                                border
                                style="width: 100%;"
                                >
                                <template slot="empty">
                                    <p>{{dataText}}</p>
                                </template>
                                <el-table-column
                                    label="序号"
                                    type="index"
                                    width="60">
                                </el-table-column>
                                <el-table-column label="工序节点">
                                    <template slot-scope="scope">
                                      <a>{{ scope.row.planName}}</a>
                                    </template>
                                </el-table-column>
                                <el-table-column label="工期计划">
                                    <template slot-scope="scope">
                                      <span>{{ scope.row.planneTime }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="计划天数">
                                    <template slot-scope="scope">
                                      <span>{{ scope.row.plannedDate }}/天</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="计划进度">
                                    <template slot-scope="scope">
                                        <el-progress :text-inside="true" :stroke-width="18" :percentage="scope.row.planProgress"></el-progress>
                                    </template>
                                </el-table-column>
                                <el-table-column label="实际进度" sortable>
                                    <template slot-scope="scope">
                                        <el-progress :text-inside="true" :stroke-width="18" :percentage="scope.row.completedProgress"></el-progress>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作">
                                    <template slot-scope="scope">
                                    <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">计划编辑</el-button>
                                    <el-button size="mini" @click="handleDelete(scope.$index, scope.row)">进度提报</el-button>
                                    </template>
                                </el-table-column>

                                <!-- 新增窗口 -->
                                <el-dialog
                                    :title="dialogTitle"
                                    :visible.sync="addFormVisible"
                                    center
                                    :append-to-body="true"
                                    :lock-scroll="false"
                                    width="500px"
                                    class="add-form"
                                >
                                    <el-form :model="addForm" ref="addForm" label-width="100px" :label-position="labelPosition" >
                                        <el-form-item label="选择继承：">
                                            <el-select v-model="addForm.levelId" placeholder="请选择" @change="changeLevel" clearable filterable>
                                                <el-option
                                                    v-for="item in optPlans"
                                                    :key="item.id"
                                                    :label="item.planName"
                                                    :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="工序名称：" required>
                                            <el-input v-model="addForm.planName" autocomplete="off" placeholder="请输入工序名称"></el-input>
                                        </el-form-item>
                                        <el-form-item label="">
                                            <el-input type="textarea" placeholder="请输入工序描述" v-model="addForm.planDescribe"></el-input>
                                        </el-form-item>
                                        <el-form-item label="计划日期" required>
                                            <el-col :span="11">
                                                <el-date-picker :disabled="addForm.levelId!=''" type="date" placeholder="选择开始日期" v-model="addForm.plannedStartTime" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                                            </el-col>
                                            <!-- <el-col class="line" :span="2" style="text-align: center;">至</el-col>
                                            <el-col :span="11">
                                                <el-date-picker type="date" placeholder="选择结束日期" v-model="addForm.plannedEndTime" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                                            </el-col> -->
                                        </el-form-item>
                                        <el-form-item label="工序时间：" required>
                                            <el-col :span="11">
                                                <el-input v-model="addForm.plannedDate" autocomplete="off"></el-input>
                                            </el-col>
                                            <el-col class="line" :span="2" style="text-align: center;">天</el-col>
                                        </el-form-item>
                                    </el-form>
                                    <div slot="footer" class="dialog-footer">
                                        <el-button @click="addFormVisible = false">取 消</el-button>
                                        <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                                    </div>
                                </el-dialog>
                            </el-table>
                        </div>
                    <!-- </div>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
import myHttp from '../../untils/port.js';
import util from "../../untils/util.js"
import base from '../../untils/base'
export default {
    data(){
        return{
            id:'',
            plan:{
                planName:'',
                planDescribe:''
            },
            labelPosition:'top',
            addFormVisible:false,
            addForm:{
                id:'',
                planName:'',
                planDescribe:'',
                plannedStartTime:'',
                plannedEndTime:'',
                plannedDate:0,
                parentId:'',
            },
            dialogTitle:"新增工序",
            tableDataEnd:[],//表格列表
            allPlanDay:0,//总工期
            curPlanDay:0,//已过工期
            dataText:'数据加载中...',
            groupId:'',
            optPlans:[],
        }
    },
    mounted(){
        this.id = this.$route.params.id;
        this.groupId = util.session.get('groupId')
        this.getData()
    },
    methods:{
        getData(){
            var that = this;
            this.curPlanDay = 0;
            this.allPlanDay = 0;
            myHttp.getProgressPlan({
                id:this.id
            }).then(function(resp){
                if(resp.data.code=="200"){
                    var list = resp.data.data.progress||[];
                    for(var i=0;i<list.length;i++){
                        list[i].planneTime = util.myTime.formatTime(list[i].plannedStartTime,'YYYY.MM.dd')+' - '+util.myTime.formatTime(list[i].plannedEndTime,'YYYY.MM.dd');
                        list[i].planProgress = that.getPlanProgress(list[i].plannedStartTime,list[i].plannedEndTime);
                        that.curPlanDay += parseInt(list[i].plannedDate);
                    }
                    that.tableDataEnd = list;
                    //that.optPlans = list
                    if(list.length==0){
                        that.dataText = '暂无数据'
                    }
                    var plan = resp.data.data.frist[0];
                    that.plan = plan;
                    that.allPlanDay = util.myTime.getdayByDate(plan.plannedStartTime,plan.plannedEndTime);
                    //that.addForm.plannedDate = parseInt(that.allPlanDay) - parseInt(that.curPlanDay);
                }else{
                    that.dataText = '暂无数据'
                }
            });
        },
        //获取计划进度
        getPlanProgress(s1,s2){
            var result = 0;
            if(new Date().getTime()>=new Date(s1).getTime()&&new Date().getTime()<new Date(s2).getTime()){
                result = util.myTime.getdayByDate(s1,new Date())+1;
            }else if(new Date().getTime()>=new Date(s2).getTime()){
                result = util.myTime.getdayByDate(s1,s2)+1;
            }
            var all = util.myTime.getdayByDate(s1,s2)+1;
            return parseFloat(((result/all)*100).toFixed(2));
        },
        //添加
        sumbitAddRow(formName){
            var that = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    that.addForm.parentId = that.id
                    that.addForm.projectId = that.groupId
                    that.addForm.plannedEndTime = util.myTime.getDateByDays(that.addForm.plannedStartTime,that.addForm.plannedDate)
                    if(new Date(that.addForm.plannedStartTime).getTime()<new Date(that.plan.plannedStartTime).getTime()){
                        that.$message.error('工序开始时间不能小于计划进度开始时间');
                    }
                    if(new Date(that.addForm.plannedEndTime).getTime()>new Date(that.plan.plannedEndTime).getTime()){
                        that.$message.error('工序结束时间不能大于计划进度结束时间');
                    }
                    myHttp.getNodeAllUpdate(that.addForm).then(function(resp){
                        if(resp.data.code=="200"){
                            that.$message.success("添加成功");
                            that.addFormVisible = false;
                            that.getData();
                        }else{
                            that.$message.error(resp.data.msg);
                        }
                    });
                }
            });
        },
        //新增
        addDute(){
            this.addForm={
                id:'',
                planName:'',
                planDescribe:'',
                plannedStartTime:this.plan.plannedStartTime,
                plannedEndTime:'',
                plannedDate:0,
                levelId:'',//同级别的id
            }
            this.getOptPlans('')
            this.dialogTitle="新增工序";
            this.addFormVisible = true;
        },
        //编辑
        handleEdit(index,row){
            this.dialogTitle="修改工序";
            this.addFormVisible = true;
            this.addForm.id = row.id;
            this.addForm.planName=row.planName
            this.addForm.planDescribe=row.planDescribe
            this.addForm.plannedStartTime=row.plannedStartTime
            this.addForm.plannedEndTime=row.plannedEndTime
            this.addForm.plannedDate=row.plannedDate
            this.addForm.levelId = row.levelId//同级别的id
            this.getOptPlans(row.plannedStartTime)
        },
        handleDelete(index,row){
            this.$router.push({name:'duteDetail',params:{id:row.id}});
        },
        /**
         * 获取可继承列表
         */
        getOptPlans(time){
            var that = this
            myHttp.getDuteTime({
                parentId:this.id,
                startDate:time,
                projectId:this.groupId,
                progressId:this.addForm.id
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.progress||[]
                    that.optPlans = list
                }
            })
        },
        //返回
        goBack(){
            this.$router.go(-1);
        },

        /**
         * 监听同级别计划
         */
        changeLevel(e){
            var list = this.optPlans
            var obj = ''
            for(var i=0;i<list.length;i++){
                if(list[i].id==e){
                    obj = list[i]
                }
            }
            this.addForm.plannedStartTime = util.myTime.getDateByDays(obj.plannedEndTime,2)
        },
    }
}
</script>
<style scoped>
    .table_wrapper{
        display:flex;
        flex-wrap: wrap;
        padding: 0;
        height: calc( 100vh - 316px );
    }
    .layui-layer-title{
        text-align: center;
        padding: 0 20px;
    }
    #qualityAdd .layui-form-label{
        text-align: left;
        padding-left: 0;
    }
    #qualityAdd .layui-input-block{
        margin-left: 0;
    }
    #qualityAdd .layui-input-inline{
        min-width: 180px;
    }
    .head-top{
        width: 100%;
        height: 70px;
        box-sizing: border-box;
        padding: 0 20px;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        background: #fff;
        border-bottom: 1px solid #ddd;
    }
    .dute-title{
        font-size: 18px;
        font-weight: bold;
        color: #707070;
    }
    .desc{
        padding: 10px;
        height: 60px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        line-height: 24px;
        color: #707070;
    }
    .layui-table-link{
        cursor: pointer;
    }
    .build-table{
        height: calc( 100% - 110px );
        padding: 0 20px;
    }
    p{
        margin: 0;
        padding: 0;
    }
</style>
